/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcGenerateV1MonthlyStatementsJobState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_GENERATE_V1_MONTHLY_STATEMENTS_JOB_STATE_ENTITY_NAME = 'ixc.generate.v1.MonthlyStatementsJob';
export const ixcGenerateV1MonthlyStatementsJobStateEntity = new schema.Entity<IxcGenerateV1MonthlyStatementsJobState>(IXC_GENERATE_V1_MONTHLY_STATEMENTS_JOB_STATE_ENTITY_NAME, {}, { idAttribute: 'jobId' });

